import { render } from "./AccreditationsSection.vue?vue&type=template&id=d6dbe6c6&scoped=true"
import script from "./AccreditationsSection.vue?vue&type=script&lang=js"
export * from "./AccreditationsSection.vue?vue&type=script&lang=js"

import "./AccreditationsSection.vue?vue&type=style&index=0&id=d6dbe6c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6dbe6c6"]])

export default __exports__